import { createSlice } from "@reduxjs/toolkit";
import Knowledge from "../../pages/BotSetting/Knowledge";

export const initialState = {
  Bot_Name:"",
  Group:"",
  Model:"",
  Embedding_Model:"",
  Bot_Description:" ",
  Knowledge_base_type:"General",
  Group_List:[],
  Model_List:[],
  Embedding_Model_List:[],
  Instruction:"",
  Sample_Question:"",
  BOT_Category:" ",
  Bot_Logo:null,
  SQL_Model:'claude-3-5-sonnet-20240620',
  loading: false,
  error_message: false,
  error:false,
  Embedding_Model:[],   
  Web_Site_List:[],
  Site_Map_List:[]
  
 
};

const Create_New_Bot_Slice = createSlice({
  name: "Create_New_Bot",
  initialState,
  reducers: {
    create_set_bot_name(state,action){
       state.Bot_Name = action.payload
    },
    create_set_Model(state,action){
        state.Model = action.payload
    },
    create_set_Embedding_Model(state,action){
        
        state.Embedding_Model = action.payload
    },
    create_set_SQL_Model(state,action){
        state.SQL_Model = action.payload
    },
    create_set_bot_description(state,action){
        state.Bot_Description = action.payload
    },
    create_set_bot_Group(state,action){

        state.Group = action.payload
    },
    create_set_bot_Knowledge_Base(state,action){
        state.Knowledge_base_type = action.payload
    },
    create_set_Bot_Group_List(state,action){
       state.Group_List = action.payload
    //    state.Group = action.payload[0].Group_ID
       state.loading=false
    },
    
    create_bot_set_start_loader(state,action){
        state.loading =true
    },
    create_bot_set_model_list(state,action){
        state.Model_List =action.payload
        if(action.payload.length !== 0 ){

            state.Model='deepseek-chat'
            state.SQL_Model='claude-3-5-sonnet-20240620'
        }
        state.loading =false
    },

    create_bot_set_embedding_model_list(state,action){
       
        state.Embedding_Model_List =action.payload
        state.Embedding_Model=process.env.REACT_APP_DEFAULT_EMBEDDING_MODEL
    }
    ,
    create_bot_fail(state,action){
        state.error_message =action.payload
        state.error=true
        state.loading =false
    },
    create_bot_sucess(state,action){
        state.error=false
        state.loading =false
        if(action.payload.Bot_ID){

            localStorage.setItem('Bot_ID',action.payload.Bot_ID)
        }
    
    },
    create_bot_reset(state,action){
        state.Bot_Name=""
        state.Group=""
        state.Model=""
        state.Bot_Description=" "
        state.Knowledge_base_type="General"
        // state.Group_List=[]
        // state.Model_List=[]
        state.Instruction=""
        state.Sample_Quuestion=""
      
        state.loading= false
        state.error_message= false
        state.error=false
        
    },

    Get_Website_Map(state,action){
        state.Site_Map_List=action.payload
        state.loading=false
    },
    
    Get_Website_Links(state,action){
        state.Web_Site_List=action.payload.Website_Knowledge_Details
        state.loading=false
    },
    set_bot_Category(state,action){
        state.BOT_Category=action.payload
    },
    update_db_bot_success(state,action){
        state.loading=false
    },
    set_bot_logo(state,action){
      
         
        state.Bot_Logo = action.payload
    },
    reset_create_new_bot_slice(state,action){
        state = initialState
    }
    // set_embedding_models(state,action){
    //     state.Embedding_Model = action.payload
    // }



    

    


  },
});

export const {
    create_set_SQL_Model,
    // set_embedding_models,
    create_set_Embedding_Model,
    create_set_bot_name,
    create_set_Model,
    create_set_bot_description,
    create_set_bot_Group,
    create_set_bot_Knowledge_Base,
    create_set_Bot_Group_List,
    create_bot_set_start_loader,
    create_bot_set_model_list,
    create_bot_set_embedding_model_list,
    create_bot_fail,
    create_bot_reset,
    create_bot_sucess,
    Get_Website_Map,
    Get_Website_Links,
    set_bot_Category,
    update_db_bot_success,
    set_bot_logo,
    reset_create_new_bot_slice
} = Create_New_Bot_Slice.actions

export default Create_New_Bot_Slice.reducer;